
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[uid]",
      function () {
        return require("private-next-pages/articles/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[uid]"])
      });
    }
  